module.exports = __webpack_public_path__ + "media/images/metronic/social/dribbble-a16fa2e9fe2fdfd43da22e971ccc892a.png";